(function () {
  'use strict';

  function initFaqAccordion(section) {
    const triggers = section.querySelectorAll('.kfaq-trigger');

    triggers.forEach(function (trigger) {
      const panelId = trigger.getAttribute('aria-controls');
      const panel = document.getElementById(panelId);
      if (!panel) return;

      /* Ensure panel is in flow but collapsed on init */
      panel.removeAttribute('hidden');
      panel.style.maxHeight = '0';
      panel.style.visibility = 'hidden';

      trigger.addEventListener('click', function () {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          close(trigger, panel);
        } else {
          /* Close any other open item in this section */
          triggers.forEach(function (t) {
            if (t !== trigger && t.getAttribute('aria-expanded') === 'true') {
              const otherId = t.getAttribute('aria-controls');
              const otherPanel = document.getElementById(otherId);
              if (otherPanel) close(t, otherPanel);
            }
          });
          open(trigger, panel);
        }
      });
    });
  }

  function open(trigger, panel) {
    trigger.setAttribute('aria-expanded', 'true');
    panel.style.visibility = 'visible';
    panel.style.maxHeight = panel.scrollHeight + 'px';
  }

  function close(trigger, panel) {
    trigger.setAttribute('aria-expanded', 'false');
    panel.style.maxHeight = '0';
    panel.addEventListener('transitionend', function hide() {
      if (trigger.getAttribute('aria-expanded') === 'false') {
        panel.style.visibility = 'hidden';
      }
      panel.removeEventListener('transitionend', hide);
    });
  }

  /* Scroll-reveal */
  function initReveal() {
    const sections = document.querySelectorAll('.kfaq-section');
    if (!sections.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      sections.forEach(function (s) { s.classList.add('is-visible'); });
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    sections.forEach(function (s) { observer.observe(s); });
  }

  function init() {
    document.querySelectorAll('.kfaq-section').forEach(initFaqAccordion);
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor live reload */
  document.addEventListener('shopify:section:load', function (e) {
    const section = e.target.querySelector('.kfaq-section');
    if (section) {
      initFaqAccordion(section);
      section.classList.add('is-visible');
    }
  });
})();
